export function tryJSONStringify(obj: any): string | null {
  try {
    return JSON.stringify(obj, null, 2);
  } catch (err) {
    return null;
  }
}

export function stringify(value: any, indention?: number) {
  return JSON.stringify(value, null, indention);
}
